import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

interface EmptyStateProps {
  icon?: IconName;
  title: ReactNode;
  sub?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon = 'inbox', title, sub, action }: EmptyStateProps) {
  return (
    <div className="sn-empty">
      <div className="sn-empty-icon">
        <Icon name={icon} size={20} />
      </div>
      <div className="sn-empty-title">{title}</div>
      {sub && <div>{sub}</div>}
      {action}
    </div>
  );
}
